import React from 'react'
import { makeStyles, Box, Button, Typography, Grid } from '@material-ui/core'
import { Link } from 'react-router-dom'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import FavoriteIcon from '@material-ui/icons/Favorite'
import CheckIcon from '@material-ui/icons/Check'

const estilos = makeStyles((theme) => ({
  botonPersonalizado: {
    background: 'linear-gradient(45deg, #018786 30%, #018786 90%)',
    border: 0,
    borderRadius: 100,
    color: 'white',
    height: 48,
    padding: '5px 20px',
    fontSize: 20,
    fontWeight: 400,
    width: 140,
    marginBottom: 50,
  },
}))

const ResultadosTres = () => {
  const classes = estilos()

  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      height="100%"
    >
      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <Box ml={4} mb={4}>
          <Typography variant="h4">Resultados</Typography>
          <Typography variant="body2" color="initial">
            Usted no presenta ningun síntoma. De igual forma, recuerde que debe
            estar atento a nuevos síntomas, mantener un distanciamiento de
            mínimo 1 metro, utilizar tapabocas en espacios abiertos o en
            compañia de otros y lavarse las manos frecuentemente.
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <Box ml={4} mb={6} alignItems="left">
          <Typography variant="h4">Tratamiento</Typography>
          <Typography variant="body2" color="initial">
            Si usted llegara a presentar algun síntoma en los días siguientes a
            esta prueba, por favor tenga en consideración las siguientes
            recomendaciones:
          </Typography>
        </Box>
      </Grid>

      <List>
        <ListItem>
          <ListItemIcon>
            <CheckIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Quédese en casa" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Aislarse (al menos 14 días)" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Vigilar aparición de nuevos síntomas" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Antipirético (Acetaminofén) en caso de fiebre" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Lavarse las manos cuidadosa y constantemente" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Tomar mucho líquido" />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Antitusígeno (en caso solo de tos) 10 cc cada 8 horas por 7 días" />
        </ListItem>
      </List>

      <Grid item>
        <Box mt={4}>
          <Link to="/" className="navbarLinks">
            <Button
              size="large"
              className={classes.botonPersonalizado}
              disableElevation
              style={{ marginLeft: '20px' }}
            >
              TERMINAR
            </Button>
          </Link>
        </Box>
      </Grid>
    </Grid>
  )
}

export default ResultadosTres
